export default __webpack_public_path__ + "static/media/41-Monaco2019.e19d4c60.jpg";